import React, { useState, useEffect } from "react";
import logo from "../../../img/logo.png";
import MultiStep from "react-multistep";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./step3";
import Step4 from "./step4";
import Step5 from "./step5";
import Step6 from "./step6";
import Step7 from "./step7";
import Footer from "./TestFooter/Footer";
import Step8 from "./step8";
import Step9 from "./step9";
import Measuretest from "./Measuretest";
import { Link } from "react-router-dom";
import VoiceTest from "./Voice2khzright";
import Warning from "./Warning";
import VoiceTestLeft from "./Voice2khzleft";
import VoiceTestRightHigh from "./Voice4khzright";
import VoiceTestLeftHigh from "./Voice6khzleft";
import NavHear from "./NavHear";
import "./heartest.css";

function Heartest() {
  // const [activeStepall, setActiveStepAll] = useState(0);

  // const handleNext = () => {
  //   setActiveStepAll((prevStep) => prevStep + 1);
  // };

  // const handleBack = () => {
  //   setActiveStepAll((prevStep) => prevStep - 1);
  // };

  //   useEffect(() => {
  //     console.log("Active Step after update:", activeStepall);
  //     // Additional logic or actions you want to perform when activeStepall changes
  //   }, [activeStepall]);

  // const steps = [
  //   { name: "welcome", component: <Step1 onNext={handleNext} /> },
  //   {
  //     name: "About",
  //     component: <Step2 onNext={handleNext} onPrev={handleBack} />,
  //   },
  //   {
  //     name: " Hearing Option",
  //     component: <Step3 onNext={handleNext} onPrev={handleBack} />,
  //   },
  //   {
  //     name: " Hearing Option",
  //     component: <Step4 onNext={handleNext} onPrev={handleBack} />,
  //   },
  //   {
  //     name: " Hearing Option",
  //     component: <Step5 onNext={handleNext} onPrev={handleBack} />,
  //   },
  //   {
  //     name: " Hearing Option",
  //     component: <Step6 onNext={handleNext} onPrev={handleBack} />,
  //   },
  //   {
  //     name: " Hearing Option",
  //     component: <Step7 onNext={handleNext} onPrev={handleBack} />,
  //   },
  //   {
  //     name: " Hearing Option",
  //     component: <Step8 onNext={handleNext} onPrev={handleBack} />,
  //   },
  //   {
  //     name: " Hearing9",
  //     component: <Step9 onNext={handleNext} onPrev={handleBack} />,
  //   },
  //   {
  //     name: " Measuretest",
  //     component: <Measuretest onNext={handleNext} onPrev={handleBack} />,
  //   },
  //   {
  //     name: " Measuretest",
  //     component: <VoiceTest onNext={handleNext} onPrev={handleBack} />,
  //   },
  //   {
  //     name: " Measuretest",
  //     component: <VoiceTestRightHigh onNext={handleNext} onPrev={handleBack} />,
  //   },

  //   {
  //     name: " Measuretest",
  //     component: <VoiceTestLeft onNext={handleNext} onPrev={handleBack} />,
  //   },

  //   {
  //     name: " Measuretest",
  //     component: <VoiceTestLeftHigh onNext={handleNext} onPrev={handleBack} />,
  //   },

  //   {
  //     name: " Measuretest",
  //     component: <Warning onNext={handleNext} onPrev={handleBack} />,
  //   },
  // ];

  return (
    <div className="test-from">
      <NavHear />{" "}
      <section className="step_form">
        <div className="container">
          {/* <Step1 /> */}
          {/* <MultiStep
            key={activeStepall}
            steps={steps}
            activeStep={activeStepall}
            showNavigation={false}
          /> */}
          <Step1 />
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default Heartest;
